module.exports = __webpack_public_path__ + "store/img/404.dced3671.jpg";